// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__4NcQ8","additionalInfo":"AgreementModal_additionalInfo__3zS5G"};